<div class="d-flex" [ngClass]="customClass">
	<ng-content select="[icon]"></ng-content>
	<ng-content select="[label]"></ng-content>
</div>
